import { useTranslation } from 'react-i18next';
import type { MediaType } from '@ooh/contracts';
import { mediaTypeColors, getMediaTypeLabel } from '../lib/map-config';
import { MapLayerLegend } from '@ooh/ui/components/map-layer-legend';
import type { LegendEntry } from '@ooh/ui/components/map-layer-legend';

interface MapLegendProps {
  /** Optional transport layer line swatch entries to display alongside media type pins. */
  transportLegendEntries?: LegendEntry[];
}

export function MapLegend({ transportLegendEntries = [] }: MapLegendProps) {
  const { t } = useTranslation('map');

  const mediaTypeEntries: LegendEntry[] = (Object.keys(mediaTypeColors) as MediaType[]).map(
    (type) => ({
      id: type,
      label: getMediaTypeLabel(type, t),
      color: mediaTypeColors[type],
      variant: 'dot' as const,
    }),
  );

  const allEntries: LegendEntry[] = [...mediaTypeEntries, ...transportLegendEntries];

  return <MapLayerLegend entries={allEntries} />;
}
